export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9102.539cfe35.jpg";